import { AnyAction, combineReducers, configureStore, Reducer } from '@reduxjs/toolkit';
import { isProduction } from 'utils/platform';
import { getQuery } from 'utils/queryUtils';

import rootReducer, { staticReducers } from './rootReducer';
import { createLogger } from 'redux-logger';
import { RootState } from 'ducks';

const customMiddlewares: any = [];
const injectedReducers: { [key: string]: Reducer<any> } = {};

if (getQuery().get('verboseStateLogging') === 'true') {
  customMiddlewares.push(createLogger({ collapsed: true }));
}

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false
    }).concat(customMiddlewares),
  devTools: !isProduction()
    ? {
        actionSanitizer: (action: any) =>
          (action.type === 'products/setArticlesInMarket' && action.payload) ||
          (action.type === 'products/fetchSuccess' && action.payload)
            ? { ...action, payload: '<<HIDE_LARGE_OBJECT>>' }
            : action,
        stateSanitizer: (state: RootState | any) => {
          return {
            ...state,
            products: {
              ...state.products,
              inMarket: '<<HIDE_LARGE_OBJECT>>',
              unavailable: '<<HIDE_LARGE_OBJECT>>',
              notInMarket: '<<HIDE_LARGE_OBJECT>>',
              productGroups: '<<HIDE_LARGE_OBJECT>>',
              articlesInMarket: '<<HIDE_LARGE_OBJECT>>'
            }
          };
        }
      }
    : false
});

export const injectReducer = <T>(key: string, reducer: Reducer<T, AnyAction>) => {
  const newReducers = combineReducers({
    ...staticReducers,
    ...injectedReducers,
    [key]: reducer
  });
  injectedReducers[key] = reducer;
  store.replaceReducer(newReducers);
};

export type AppDispatch = typeof store.dispatch;

export default store;
